import { MessageCircle, NotebookPen, Layout } from "lucide-react";

interface ChatTabsProps {
  activeTab: 'chat' | 'notebook' | 'canvas';
  onTabChange: (tab: 'chat' | 'notebook' | 'canvas') => void;
  showCanvasTab?: boolean;
}

const ChatTabs = ({ activeTab, onTabChange, showCanvasTab = false }: ChatTabsProps) => {
  return (
    <div className="flex justify-center lg:justify-center mb-4">
      <div className="p-1 rounded-2xl flex bg-[#f0f0ef] border-teal-300 w-full lg:w-auto" style={{ fontFamily: 'Lexend Deca' }}>
        <button
          onClick={() => onTabChange('chat')}
          className={`px-4 py-1.5 rounded-2xl text-sm font-medium transition-all duration-300 ease-out flex items-center justify-center gap-2 flex-1 lg:flex-initial ${
            activeTab === 'chat'
              ? 'bg-background text-foreground shadow-sm animate-scale-in'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <MessageCircle className="w-4 h-4" />
          Chat
        </button>
        
        <button
          onClick={() => onTabChange('notebook')}
          className={`px-4 py-1.5 rounded-2xl text-sm font-medium transition-all duration-300 ease-out flex items-center justify-center gap-2 flex-1 lg:flex-initial ${
            activeTab === 'notebook'
              ? 'bg-background text-foreground shadow-sm animate-scale-in'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <NotebookPen className="w-4 h-4" />
          Notebook
        </button>
        
        {showCanvasTab && (
          <button
            onClick={() => onTabChange('canvas')}
            className={`px-4 py-1.5 rounded-2xl text-sm font-medium transition-all duration-300 ease-out flex items-center justify-center gap-2 flex-1 lg:flex-initial ${
              activeTab === 'canvas'
                ? 'bg-background text-foreground shadow-sm animate-scale-in'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Layout className="w-4 h-4" />
            Canvas
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatTabs;
